import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
// import { useEffect } from 'react';
import Login from './components/login/Login';
import Home from "./components/home/Home";
// import HomeWithoutSplash from "./components/home/Home";
// import SidebarBottom from "./components/home/SidebarBottom";
import Header from './components/header/Header';
import ProtectedRoutes from './components/Auth/Protected';
import LogoutComponent from './components/logout/LogoutPageComponent';
import Manage from './components/manage/Manage';


function App() {
  return (
    <div>
      <Routes>
        <Route path="/login" element={<><Login /></>}> </Route>
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<> <Header /><Home /> </>}> </Route>
          <Route path="/home" element={<> <Header /><Home /> </>}> </Route>
          <Route path="/manage" element={<> <Header /><Manage /> </>}> </Route>
          <Route path="/logout" element={<><LogoutComponent /></>}> </Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
}

export default App;